module.exports = "<h1>auth module</h1>\n\n<ng-outlet></ng-outlet>"


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/components/auth/auth.html
 ** module id = 215
 ** module chunks = 0
 **/